import type { CDNConfig } from "$src/core/models/image";
import CustomPlatform from "$src/core/utils/platform/platform";

const EXTENSION = CustomPlatform.select({
  ios: "avif",
  android: "webp",
  tvOS: "avif",
  androidTV: "webp",
  web: "avif",
  default: "webp",
});

const buildResponsiveUri = (
  uri: string,
  options: { width?: number; height?: number },
): string => {
  let url: URL;
  try {
    url = new URL(uri);
  } catch {
    return uri;
  }

  if (url.hostname.includes("prepr.io")) {
    let { pathname } = url;

    const extension = pathname.split(".").pop();
    if (extension) {
      pathname = pathname.replace(`.${extension}`, "");
    }

    const segments = pathname.split("/");

    const idSegment = segments.pop();
    if (idSegment) {
      pathname = pathname.replace(`/${idSegment}`, "");
    }

    const widthSegment = segments.find((segment) => segment.startsWith("w_"));
    if (widthSegment) {
      pathname = pathname.replace(`/${widthSegment}`, "");
    }

    const heightSegment = segments.find((segment) => segment.startsWith("h_"));
    if (heightSegment) {
      pathname = pathname.replace(`/${heightSegment}`, "");
    }

    if (options.width) {
      pathname = pathname.concat(`/w_${options.width}`);
    }

    if (options.height) {
      pathname = pathname.concat(`/h_${options.height}`);
    }

    pathname = pathname.concat(`/${idSegment}`);
    pathname = pathname.concat(`.${EXTENSION}`);

    url.pathname = pathname;

    return url.toString();
  }

  return uri;
};

const cdn: CDNConfig = {
  image: {
    buildResponsiveUri,
  },
};

export default cdn;
